import {CachingServiceEntities} from "../../../../@bizkeytech";

export enum CachingServiceLocalStorageKeys {
    dataGridSavedState = "data-grid-saved-state",
    cachedUrl = "cached-url",
    bizFileFileBaseUrl = "biz-file-file-base-url",
    bizFileFileToken = "biz-file-file-token",
    partnerColorScheme = "partner-color-scheme",
}

export type CachingServiceLocalStorageKeysType = ReverseMap<typeof CachingServiceLocalStorageKeys>;


export enum CachingServiceCookiesKeys {
    dataGridSavedState = "data-grid-saved-state",
    cachedUrl = "cached-url",
    bizFileFileBaseUrl = "biz-file-file-base-url",
    bizFileFileToken = "biz-file-file-token",
    partnerColorScheme = "partner-color-scheme",
}

export type CachingServiceCookiesKeysType = ReverseMap<typeof CachingServiceCookiesKeys>;

export enum AppCachingServiceEntities {

}


export type CachingServiceEntitiesType =
    ReverseMap<typeof AppCachingServiceEntities>
    | ReverseMap<typeof CachingServiceEntities>;
